import Highlighter from 'react-highlight-words';

import styles from './style.less';

const HighlighterCustom = ({ textToHighlight, searchTerm }) => {
  if (searchTerm && textToHighlight)
    return (
      <Highlighter
        highlightTag="span"
        highlightClassName={styles.mark}
        searchWords={[searchTerm]}
        autoEscape
        textToHighlight={textToHighlight ? String(textToHighlight) : ''}
      />
    );

  return textToHighlight ?? '-';
};

export default HighlighterCustom;
